import React from "react";
import pbLogo from "../../assets/images/dashboard.svg";
import { ReactComponent as BotIcon } from "../../assets/icons/bot.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/icons/arrowRight.svg";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrowLeft.svg";
import { Link } from "react-router-dom";
import "../SupportingApp/SupportingApp.scss";
import Chatbot from "../../components/Chatbot/Chatbot";
import { useTranslation } from "react-i18next";
import { logActivity } from "../../helpers/activityLog";

const dashboards = [
  {
    name: "Executive Dashboard",
    link: "/dashboard/executive-dashboard",
  },
  {
    name: "District Dashboard",
    link: "/dashboard/district-dashboard",
  },
  {
    name: "Fence Dashboard",
    link: "/dashboard/fence-dashboard",
  },
  {
    name: "Amara Dashboard",
    link: "/dashboard/amara-dashboard",
  },
  {
    name: "Urban Environment Department KPIs",
    link: "/dashboard/urban-environment-department-kpis",
  },
  {
    name: "Audit Report",
    link: "/dashboard/audit-report",
  },
  {
    name: "Supervision Streams",
    link: "/dashboard/supervision-streams",
  },
  /*
  {
    name: "Operation Room Tracker",
    link: "/dashboard/operation-room-tracker",
  },
  {
    name: "IT Tracker",
    link: "/dashboard/it-tracker",
  }
    */
  {
    name: "مشاريع NHC",
    link: "/dashboard/housing-projects",
  },
  {
    name: "صور البلاغات",
    link: "/dashboard/photos-reports",
  },
  {
    name: "رصد بلاغات المظلات عن طريق مشهد",
    link: "/dashboard/parachutes-monitoring-reports",
  },
  {
    name: "Ministry KPIs",
    link: "/dashboard/ministry-kpis",
  },
];

const Dashboards = () => {
  const { t } = useTranslation();
  return (
    <div className='SupportingApp'>
      <Chatbot />
      <div className='left'></div>
      <div className='right'>
        <Link to='/'>
          <ArrowLeftIcon className='back' title='Back' />
        </Link>
        <h1>{t("Dashboards")}</h1>

        <div className='apps'>
          {dashboards.map((i) => (
            <a
              key={i.name}
              href={i.link}
              className='app'
              onClick={() =>
                logActivity({
                  eventCategory: "Dashboards",
                  eventDescription: `Opened ${i.name} from Landing Page`,
                  moduleName: i.name,
                })
              }
            >
              <div className='app_img'>
                <img src={pbLogo} alt='Mashhad Logo' />
              </div>
              <div className='app_content'>
                <p>{i.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboards;
